import { useState } from 'react';

import QaSpecCharacteristicGrid from './QaSpecCharacteristicGrid';

import { useContaminant } from 'pages/qa-spec/hooks/useContaminant';
import { EDIT_SECTION } from 'pages/qa-spec/components/edit-tab-checker';
import { useGetQaContaminantCharacteristicsSnapshot } from './snapshot/hooks';

const ContaminantCharacteristic = (props) => {
  const { productId } = props;

  const [isGridEditing, setIsGridEditing] = useState(false);

  const {
    gridInst,
    analysisNotExecuted, // TODO: Update it to analysisExecuted.
    rowData,
    columnDefs,
    saveData,
    loading,
    addNewRow,
    deleteData,
    cancelEdit,
    selectedRow,
    selectRow,
    onCellEditingStopped,
    gridTitle,
  } = useContaminant({
    productId,
    isGridEditing,
  });

  const { contaminantCharacteristicsSnapshot, analysisNotExecutedSnapshot } =
    useGetQaContaminantCharacteristicsSnapshot();

  const onEdit = (isEditing) => {
    setIsGridEditing(isEditing);
  };

  return (
    <QaSpecCharacteristicGrid
      type={EDIT_SECTION.PROD_SPEC_CONTAMINANT}
      title={gridTitle}
      loading={loading}
      gridInst={gridInst}
      columnDefs={columnDefs}
      rowData={rowData}
      handleSave={saveData}
      handleAdd={addNewRow}
      handleDelete={deleteData}
      selectedRow={selectedRow}
      onRowSelected={selectRow}
      handleCancel={cancelEdit}
      analysisNotExecuted={analysisNotExecuted}
      analysisNotExecutedSnapshot={analysisNotExecutedSnapshot}
      isShowAnalysisNotExecuted
      productId={productId}
      onCellEditingStopped={onCellEditingStopped}
      snapshotGridValues={contaminantCharacteristicsSnapshot}
      onEditChange={onEdit}
      fieldPathTooltip='qaSpecification.productSpecification.analysisNotExecuted3'
    />
  );
};

export default ContaminantCharacteristic;
